import React, { forwardRef } from "react";
import { shallowEqual } from "react-redux";
import { useUscDispatch, useUscSelector } from "../../../../redux/store";
import { useUscLabel } from "../../../../utils/labels";
import { showModal } from "../../../../../../common-deprecated/redux/actions/ModalActions";
import { MODAL_CONTENT } from "../../../../../../common-deprecated/utils/modalConstants";
import { CommonLabel } from "../../../../../../common-deprecated/utils/commonLabels";
import { UscDisclaimerType } from "../../../../../shared-logic/types/UscCommonTypes";
import { formatPriceIntl } from "../../../../../../common-deprecated/priceUtils";
import DisclaimerIconWrapper from "../../common/DisclaimerIconWrapper";
import { enableUscMonthlyRate } from "../../../../utils/settings";
import { trackAccessoryReadMoreClick } from "../../../../utils/tracking";
import Card from "../../styles/molecules/Card";
import Text from "../../../../../shared-components/toyota/styles/atoms/Text";
import Button from "../../../../../shared-components/toyota/styles/atoms/Button";
import * as CardStyles from "../../styles/molecules/Card.styles";
import { type UscAccessoryType, getAccessoryPackPriceSelector } from "../../../../utils/accessoryUtils";

const AccessoryItem = forwardRef<HTMLDivElement, { accessory: UscAccessoryType; index: number }>(
    ({ accessory, index }, ref) => {
        const dispatch = useUscDispatch();
        const accessoryPrice = useUscSelector(getAccessoryPackPriceSelector(accessory), shallowEqual);
        const uscContext = useUscSelector((state) => state.vehicle.type);
        const commonSettings = useUscSelector((state) => state.commonSettings);
        const financeEnabled = useUscSelector(({ commonSettings: financeCommonSettings, uscSettings, vehicle }) =>
            enableUscMonthlyRate(financeCommonSettings, uscSettings, vehicle.result, vehicle.type),
        );
        const loadingLabel = useUscLabel("uscLoading");

        const showDescriptionModal = (): void => {
            dispatch(
                showModal({
                    type: MODAL_CONTENT,
                    content: accessory.description,
                    title: accessory.name,
                }),
            );
            trackAccessoryReadMoreClick(uscContext, accessory.name);
        };

        return (
            <Card variant="accessories" cardRef={ref} data-index-number={index}>
                {accessory.imageUrl && <img src={accessory.imageUrl} alt={accessory.name || ""} />}
                <CardStyles.Body>
                    <Text tag="h3" variant="h6">
                        {accessory.name}
                    </Text>
                    <Button variant="link" size="small" onClick={showDescriptionModal}>
                        <CommonLabel label="readMore" />
                    </Button>
                </CardStyles.Body>
                {accessoryPrice && (
                    <CardStyles.Footer>
                        <div>
                            <Text tag="div" variant="body-regular">
                                {accessoryPrice.cashLoading
                                    ? loadingLabel
                                    : formatPriceIntl(commonSettings, accessoryPrice.cashPrice.cashPriceInclVat)
                                          .primaryPrice}
                                <DisclaimerIconWrapper type={UscDisclaimerType.Accessory} />
                            </Text>
                            {financeEnabled && (
                                <Text tag="div" variant="body-book" color="grey-7">
                                    {!accessoryPrice.monthlyLoading && !!accessoryPrice.monthlyPrice && (
                                        <span
                                            dangerouslySetInnerHTML={{ __html: accessoryPrice.monthlyPriceFormatted }}
                                        />
                                    )}
                                </Text>
                            )}
                        </div>
                    </CardStyles.Footer>
                )}
            </Card>
        );
    },
);

export default AccessoryItem;
